import React from 'react';

const CheckIcon = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.00016 12.6667L2.3335 9.00004L1.2735 10.06L6.00016 14.7867L14.7268 6.06004L13.6668 5.00004L6.00016 12.6667Z"
      fill="currentColor"
    />
  </svg>
);

export default CheckIcon;
